var _style, _defs, _defs2, _g, _defs3, _defs4, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoison(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 30",
    style: {
      enableBackground: "new 0 0 110 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_3_);}\r\n\t.st1{enable-background:new    ;}\r\n\t.st2{clip-path:url(#SVGID_7_);}\r\n\t.st3{fill:#B563CE;}\r\n\t.st4{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("line", {
    id: "SVGID_1_",
    x1: 0,
    y1: 30,
    x2: 0,
    y2: 0
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("line", {
    id: "SVGID_2_",
    x1: 110,
    y1: 0,
    x2: 110,
    y2: 30
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    style: {
      overflow: "visible"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M106,31"
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_6_",
    d: "M-4,31"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_6_",
    style: {
      overflow: "visible"
    }
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Tag_Poison",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4_2_",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2_1_",
    className: "st3",
    d: "M15,0h80c8.3,0,15,6.7,15,15l0,0c0,8.3-6.7,15-15,15H15C6.7,30,0,23.3,0,15l0,0 C0,6.7,6.7,0,15,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    className: "st4",
    d: "M4.9,7C4.3,7,3.7,6.6,3.5,6C3.2,6.6,2.6,7,2,7C1.3,7,0.7,6.5,0.4,5.8C0.2,6.5-0.4,7-1.1,7 C-2.1,7-3,5.9-3,4.5c0-0.3,0-0.6,0.1-0.9C-4.2,2.5-5,0.9-5-0.8C-5-4.2-1.9-7,2-7s7,2.8,7,6.2C9,1,8.1,2.7,6.7,3.8 C6.8,4,6.8,4.3,6.8,4.5C6.8,5.9,6,7,4.9,7z M1.9-3.8c-2.3,0-4.1,1.4-4.1,3.1s1.9,3.1,4.1,3.1S6.1,1,6.1-0.7S4.2-3.8,1.9-3.8z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.8,16.8v3.5h-2.1v-10h3.9c0.7,0,1.4,0.1,2,0.4s1,0.7,1.3,1.2s0.5,1.1,0.5,1.7c0,1-0.3,1.7-1,2.3 c-0.7,0.6-1.6,0.8-2.8,0.8H38.8z M38.8,15.1h1.8c0.5,0,1-0.1,1.2-0.4s0.4-0.6,0.4-1.1c0-0.5-0.1-0.9-0.4-1.2S41.2,12,40.7,12h-1.9 V15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M53.9,15.6c0,1-0.2,1.8-0.5,2.6s-0.8,1.3-1.5,1.7c-0.6,0.4-1.4,0.6-2.2,0.6c-0.8,0-1.6-0.2-2.2-0.6 s-1.1-1-1.5-1.7s-0.5-1.6-0.5-2.5v-0.5c0-1,0.2-1.8,0.5-2.6s0.9-1.3,1.5-1.7s1.4-0.6,2.2-0.6s1.6,0.2,2.2,0.6s1.1,1,1.5,1.7 c0.4,0.7,0.5,1.6,0.5,2.6V15.6z M51.9,15.1c0-1-0.2-1.8-0.6-2.4s-0.9-0.8-1.6-0.8c-0.7,0-1.2,0.3-1.6,0.8s-0.6,1.3-0.6,2.4v0.5 c0,1,0.2,1.8,0.6,2.4s0.9,0.8,1.6,0.8c0.7,0,1.2-0.3,1.6-0.8s0.6-1.3,0.6-2.4V15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M57.6,20.3h-2.1v-10h2.1V20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M64.7,17.7c0-0.4-0.1-0.7-0.4-0.9s-0.8-0.4-1.5-0.7c-0.7-0.2-1.3-0.5-1.7-0.7C60,14.9,59.4,14,59.4,13 c0-0.5,0.2-1,0.5-1.4c0.3-0.4,0.7-0.8,1.3-1c0.6-0.2,1.2-0.4,1.9-0.4c0.7,0,1.3,0.1,1.9,0.4s1,0.6,1.3,1.1c0.3,0.5,0.5,1,0.5,1.6 h-2.1c0-0.5-0.1-0.8-0.4-1.1s-0.7-0.4-1.2-0.4c-0.5,0-0.9,0.1-1.2,0.3s-0.4,0.5-0.4,0.8c0,0.3,0.2,0.6,0.5,0.8 c0.3,0.2,0.8,0.4,1.4,0.6c1.2,0.4,2,0.8,2.5,1.3c0.5,0.5,0.8,1.2,0.8,1.9c0,0.9-0.3,1.5-1,2s-1.5,0.7-2.6,0.7 c-0.8,0-1.5-0.1-2.1-0.4s-1.1-0.7-1.4-1.2c-0.3-0.5-0.5-1.1-0.5-1.7h2.1c0,1.1,0.7,1.6,2,1.6c0.5,0,0.9-0.1,1.1-0.3 S64.7,18,64.7,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M76.3,15.6c0,1-0.2,1.8-0.5,2.6s-0.8,1.3-1.5,1.7c-0.6,0.4-1.4,0.6-2.2,0.6c-0.8,0-1.6-0.2-2.2-0.6 s-1.1-1-1.5-1.7s-0.5-1.6-0.5-2.5v-0.5c0-1,0.2-1.8,0.5-2.6c0.4-0.7,0.9-1.3,1.5-1.7c0.6-0.4,1.4-0.6,2.2-0.6s1.6,0.2,2.2,0.6 c0.6,0.4,1.1,1,1.5,1.7c0.4,0.7,0.5,1.6,0.5,2.6V15.6z M74.2,15.1c0-1-0.2-1.8-0.6-2.4s-0.9-0.8-1.6-0.8c-0.7,0-1.2,0.3-1.6,0.8 s-0.6,1.3-0.6,2.4v0.5c0,1,0.2,1.8,0.6,2.4s0.9,0.8,1.6,0.8c0.7,0,1.2-0.3,1.6-0.8s0.6-1.3,0.6-2.4V15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.9,20.3h-2.1l-4-6.5v6.5h-2.1v-10h2.1l4,6.6v-6.6h2V20.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoison);
export default __webpack_public_path__ + "static/media/poison.85e77d1849f1a3843ca958fe0a3c7d0a.svg";
export { ForwardRef as ReactComponent };